module.exports = __webpack_public_path__ + "static/media/21159284469_9b5633c1e3_o.639e5473.jpg";